export function initMemberNumberRequired() {

  const requiredMemberNumber1: HTMLElement | null = document.getElementById('memberstatus-1');
  const requiredMemberNumber2: HTMLElement | null = document.getElementById('memberstatus-2');
  const nonrequiredMemberNumber: HTMLElement | null = document.getElementById('memberstatus-3');
  if (!nonrequiredMemberNumber ) {
    return;
  }
  nonrequiredMemberNumber?.addEventListener('change', () => {
    if (nonrequiredMemberNumber instanceof HTMLInputElement) {
      if (nonrequiredMemberNumber.checked) {
        let memberStatus = document.getElementById('membershipnumber');
        let requiredSign = document.getElementById('requiredSign');
        if (memberStatus && requiredSign) {
          memberStatus.removeAttribute('required');
          requiredSign.setAttribute('hidden', '');
        }
      }
    }
  });

  requiredMemberNumber1?.addEventListener('change', () => {
    if (requiredMemberNumber1 instanceof HTMLInputElement) {
      if (requiredMemberNumber1.checked) {
        let memberStatus = document.getElementById('membershipnumber');
        let requiredSign = document.getElementById('requiredSign');
        if (memberStatus && requiredSign) {
          memberStatus.setAttribute('required', '');
          requiredSign.removeAttribute('hidden');
        }
      }
    }
  });

  requiredMemberNumber2?.addEventListener('change', () => {
    if (requiredMemberNumber2 instanceof HTMLInputElement) {
      if (requiredMemberNumber2.checked) {
        let memberStatus = document.getElementById('membershipnumber');
        let requiredSign = document.getElementById('requiredSign');
        if (memberStatus && requiredSign) {
          memberStatus.setAttribute('required', '');
          requiredSign.removeAttribute('hidden');
        }
      }
    }
  });
}
